<template>
  <v-btn
    color="primary"
    block
    :height="mainButtonHeight"
    @click="$emit('next')"
    dark
    tile
    :class="device.isDesktop ? '' : 'mb-4'"
  >
    <span style="font-weight: bold; font-size: 1.2rem">
      <v-icon>mdi-chevron-right</v-icon>
      {{ $t("continue") }}
      (+)
    </span>
  </v-btn>
</template>

<script>
export default {
  computed: {
    mainButtonHeight() {
      if (this.device?.isMobile) return "48";
      if (this.device?.isTablet) return "64";
      return "80";
    },
  },
};
</script>
